import { ReactNode } from "react"

export default function CwPageHeader({
  title,
  subtitle,
  action,
}: {
  title: string
  subtitle?: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-6">
      <div>
        <h1 className="font-oswald text-3xl md:text-4xl font-bold tracking-wide text-primary-dark">
          {title}
        </h1>
        {subtitle ? (
          <p className="font-source text-gray-600 mt-1">{subtitle}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  )
}
